import { render, staticRenderFns } from "./ReimbursementFeatureDetail.vue?vue&type=template&id=04073228&scoped=true"
import script from "./ReimbursementFeatureDetail.vue?vue&type=script&lang=js"
export * from "./ReimbursementFeatureDetail.vue?vue&type=script&lang=js"
import style0 from "./ReimbursementFeatureDetail.vue?vue&type=style&index=0&id=04073228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04073228",
  null
  
)

export default component.exports